module.exports = __webpack_public_path__ + "static/media/edit-icon.cc131c2c.svg";